import { cn } from "@/lib/utils";

type Props = {
  size?: number | string;
  className?: string;
  theme?: "light" | "dark";
};

export const Logo = ({ size = 32, className, theme = "dark" }: Props) => {
  // Theme 'dark' means the logo is on a dark background, so text is white.
  // Theme 'light' means the logo is on a light background, so text is dark (slate-900).
  const textColor = theme === "dark" ? "white" : "#0f172a";

  // Calculate width/height if it's a number, preserving aspect ratio approx 300:80 (3.75:1)
  // If size is provided as number, treat it as height? The original component used width={size} height={size}.
  // The original image was square-ish or just passed size to both? 
  // SVG viewBox is 300 80.
  // If passing size=32 (height), width would be 120.
  // Let's assume 'size' usually refers to height for a logo strip, but if the original was square, usage might differ.
  // The previous implementation used size for BOTH width and height in <img>.
  // If usages expect a square box, this long logo will be tiny.
  // However, "theResumeLight.svg" might have been a wordmark too.
  // Let's just pass style height={size} and auto width.

  const heightVal = typeof size === 'number' ? `${size}px` : size;

  return (
    <svg
      viewBox="0 0 300 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-auto", className)}
      style={{ height: heightVal }}
    >
      {/* Icon Part */}
      <g transform="translate(10, 15)">
        <rect x="0" y="0" width="50" height="50" rx="12" fill="#F59E0B" fillOpacity="0.1" stroke="#F59E0B" strokeWidth="2" />
        <path d="M15 25L22 32L35 18" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      {/* Text Part */}
      <text x="75" y="52" fontFamily="'Instrument Serif', serif" fontSize="42" fill={textColor}>the</text>
      <text x="130" y="52" fontFamily="'Plus Jakarta Sans', sans-serif" fontWeight="700" fontSize="42" fill={textColor}>Recruit</text>
      {/* Dot */}
      <circle cx="285" cy="48" r="4" fill="#F59E0B" />
    </svg>
  );
};